module.exports = __webpack_public_path__ + "images/a56ad14dcbe2ee7889f9422483b5fe67.svg";